export default "__VITE_ASSET__e959e1ac__"